import ChangePasswordModal from '@app/components/ChangePasswordModal'
import { changePasswordActionCreators } from '@app/components/ChangePasswordModal/modules/changePassword'
import ContactProfileImage from '@app/components/ContactProfileImage'
import FeedbackButton from '@app/components/Feedback'
import GlobalSearch from '@app/components/GlobalSearch'
import PreferencesModal from '@app/components/PreferencesModal'
import { preferencesEditActionCreators } from '@app/components/PreferencesModal/modules/preferencesEdit'
import ReleaseNotesButton from '@app/components/ReleaseNotes'
import SystemNotificationsIcon from '@app/components/SystemNotificationsIcon'
import VideoModalButton from '@app/components/VideoModalButton'
import * as AccountModule from '@app/store/modules/account'
import { bindFunctions } from '@app/utils/class'
import { TUTORIALS } from '@app/utils/tutorials'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as React from 'react'
import { Route, RouteComponentProps, Switch } from 'react-router-dom'
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from 'reactstrap'

import { actionCreators as LoginActions } from '@app/store/modules/account'

import { NotificationContext } from '@app/models/enums'
import './Header.css'

interface IComponents {
  toggleClick: () => void
}

type HeaderProps = AccountModule.ICurrentUserState &
  RouteComponentProps<{}> &
  IComponents &
  typeof LoginActions &
  typeof changePasswordActionCreators &
  typeof preferencesEditActionCreators

export default class Header extends React.PureComponent<HeaderProps, {}> {
  private userRealName: string

  public constructor(props: any) {
    super(props)

    bindFunctions(this)
  }

  public render() {
    if (!this.props.user) {
      return null
    }

    if (this.props.user) {
      this.userRealName = `${this.props.user.firstName} ${this.props.user.lastName}`
    }

    return (
      <nav className='navbar navbar-expand-lg navbar-light bg-light'>
        <button
          className='mr-2 hamburgerButton'
          onClick={() => this.props.toggleClick()}
        >
          <FontAwesomeIcon icon={['fal', 'bars']} fixedWidth />
        </button>
        <GlobalSearch
          className='my-2 my-lg-0 mr-4 d-none d-lg-block flex-grow-1'
          id='header-search'
        />
        <div className='text-muted ml-auto'>
          <a
            className='mr-3 d-inline d-lg-none'
            onClick={this._navigateToSearch}
            title='Search'
          >
            <FontAwesomeIcon icon={['fal', 'search']} fixedWidth size='lg' />
          </a>

          <Switch>
            {TUTORIALS.filter(t => !!t.showOnRoute).map((t, idx) => (
              <Route key={idx} path={t.showOnRoute} component={() =>
                <VideoModalButton className='mr-3' videoId={t.videoId} title={t.title} />
              } />
            ))}
          </Switch>

          <a className='mr-3 d-inline' onClick={() => window.open('/map')}>
            <FontAwesomeIcon icon={['fal', 'map']} fixedWidth size='lg' />
          </a>
          <FeedbackButton className='mr-3' />
          <ReleaseNotesButton className='mr-3' />
          <SystemNotificationsIcon
            context={NotificationContext.Standard}
            className='d-inline-block mr-3'
          />
          <SystemNotificationsIcon
            context={NotificationContext.Calendar}
            className='d-inline-block mr-3'
          />
          <UncontrolledDropdown
            nav
            inNavbar
            style={{ listStyle: 'none', display: 'inline' }}
          >
            <DropdownToggle
              className='text-muted'
              nav
              style={{ display: 'inline', padding: 0 }}
            >
              <ContactProfileImage contact={this.props.user.id} size={28} />
              <span className='ml-2 d-none d-md-inline'>
                {this.userRealName}
              </span>
            </DropdownToggle>
            <DropdownMenu right>
              <DropdownItem onClick={this.props.showPreferencesModal}>
                Preferences
              </DropdownItem>
              <DropdownItem onClick={this._navigateToProfile}>
                Profile
              </DropdownItem>
              <DropdownItem onClick={this.props.showChangePasswordModal}>
                Change Password
              </DropdownItem>
              <DropdownItem
                onClick={() => {
                  this.props.clearLoggedInUser()
                }}
              >
                Log off
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
          <ChangePasswordModal />
          <PreferencesModal />
        </div>
      </nav>
    )
  }

  private _navigateToProfile() {
    if (!this.props.user) {
      return
    }

    this.props.history.push(`/connection/${this.props.user.id}`)
  }

  private _navigateToSearch() {
    this.props.history.push('/search')
  }
}
